import type { CommonMessages } from '../types';

const messages: CommonMessages = {
  colon: '：',
  export: '导出',
  delete: '删除',
  view: '访问文档',
  send: '发送',
  sending: '发送中',
  search: '搜索',
  find: '查找',
  save: '保存',
  saved: '已保存',
  cancel: '取消',
  close: '关闭',
  name: '名称',
  value: '值',
  description: '说明',
  updatedIn: '最后修改时间：',
  defaultFolder: '根目录',
  codeGenerate: '生成代码',
  responsible: '责任人',
  format: '格式',
  copyToClipboard: '点击复制',
  'message.requestException': '请求异常',
  'message.requestError': '请求发生错误',
  'message.exportSuccess': '导出成功',
  'message.networkFailure': '网络错误，请检查网络，或者稍后再试',
  'message.serverFailure': '服务器异常，请稍后再试',
  'button.text.reload': '重新加载',
  'message.loadError.checkNetwork': '加载出错，请检查网络是否异常',
  'message.scriptError.checkNetworkOrContactStaff':
    '发生异常错误，请尝试"重新加载"，或"联系我们"帮你解决！',
  dismiss: '不再提示',
  moreHelp: '更多帮助',
  noContent: '没有内容',
  enumeratedValue: '枚举值',
  more: '更多',
  download: '下载',
  downloadFileAndUnitSize: '下载文件（{unitSize}）',
  viewAsText: '仍以文本查看',
  copyContent: '复制内容',
  wrap: '自动换行',
  request: '请求',
  response: '响应',
  'request.example.title.right': '请求示例',
  'request.example.title.center': '请求示例',
  'response.example.title.right': '响应示例',
  'response.example.title.center': '响应示例',
  redirect: '重定向',
  console: '控制台',
  header: 'Header',
  cookie: 'Cookie',
  selectCharset: '请选择字符集',
  isCopied: '已复制',
  failToCopied: '复制失败，请手动复制',
  clone: '克隆',
  'runner.tryItOut': '在线运行',
  'runner.selectCase': '选择用例',
  tryItOut: '调试',
  runInApp: 'Run in {appName}',
  'customDomain.cname.alibaba': '域名在阿里云备案',
  'customDomain.cname.otherCloud': '域名在腾讯云备案',
  'customDomain.cname.HK': '香港服务器，略慢',
  graphqlGetTips: "发出 HTTP GET 请求时，应在 Params 的 'query' 字段中定义 GraphQL 查询",
  onlineShareHasBeenCopyToTeam:
    '已将 API 文档 <strong>{onlineShareName}</strong> 克隆到团队 <strong>{teamName}</strong>',
  'onlineShare.export': '导出数据',
  'onlineShare.export.dataType': '选择数据格式',
  'exportData.export.openapi.version': 'OpenAPI Spec 版本',
  'exportData.export.openapi.version.31': 'OpenAPI 3.1',
  'exportData.export.openapi.version.30': 'OpenAPI 3.0',
  'exportData.export.openapi.version.20': 'Swagger 2.0',
  'exportData.export.openapi.includeExtension':
    '包含 {appName} 扩展的 OpenAPI 字段（x-{appNameLower}-***）',
  'exportData.export.openapi.includeExtension.no': '不包含',
  'exportData.export.openapi.includeExtension.yes': '包含',
  'exportData.export.openapi.tags': '将 API 文档的目录，作为 Tags 字段导出',
  'exportData.export.openapi.tags.yes': '是',
  'exportData.export.openapi.tags.no': '否',
  'onlineShare.clone': '克隆到我的 {appName}',
  'onlineShare.notExisted': '当前文档不存在或已删除',
  'onlineShare.noAccess': '你没有权限访问这份文档',
  'onlineShare.expired.subTitle': '请联系文档分享者',
  'apidoc.unPublish': '当前文档暂未发布',
  'apidoc.unPublish.subTitle': '请联系文档发布者先发布文档，再访问当前 URL。',
  'onlineShare.needPassword': '当前文档需要密码才可访问',
  'onlineShare.sendCodeSuccess': '如果你的邮箱处在白名单中，将很快收到验证码',
  'onlineShare.resource.notExisted.title': '404',
  'onlineShare.resource.notExisted.subTitle': '页面不存在',
  'onlineShare.resource.notExisted.reload': '重新加载页面',
  'exportData.appDocumentation.json': '接口文档.{appNameLower}.json',
  backToHome: '返回首页',
  'email.auth.tip': '当前文档需要邮件验证码才能访问',
  'customDomain.error.tip': 'CNAME 配置有误，请检查以下规范',
  'customDomain.error.tip2': 'CNAME 配置有误',
  previous: '上一页',
  next: '下一页',
  'message.noPrivilege': '没有权限',
  'onlineShare.expired': '当前文档的访问时间已过期',
  'onlineShare.notShared': '当前文档暂未分享',

  'docsSite.enableVibeCodingViaMCP.suffix': 'API 文档',
  'docsSite.enableVibeCodingViaMCP': 'AI 编程（使用 MCP）',
  'docsSite.enableVibeCodingViaMCP.modal.title': 'AI 编程（使用 MCP）',
  'docsSite.enableVibeCodingViaMCP.modal.description':
    '## 🚀 配置\n\n### 前置条件\n\n- 已安装 Node.js 环境（版本号 >= 18，推荐最新的 LTS 版本）\n- 任意一个支持 MCP 的 IDE：\n  - Cursor\n  - VSCode + Cline 插件\n\n### 配置 IDE\n\n将下面 JSON 配置添加到 IDE 对应的 MCP 配置文件里：\n\n```json\n{\n  "mcpServers": {\n    "{serverName}": {\n      "command": "npx",\n      "args": [\n        "-y",\n        "{appNameLower}-mcp-server@latest",\n        "--site-id={docsSiteId}"\n      ]\n    }\n  }\n}\n```\n\n如果使用 Windows 操作系统，而上文的配置文件无法正常工作，请使用如下配置文件：\n\n```json\n{\n  "mcpServers": {\n    "{serverName}": {\n      "command": "cmd",\n      "args": [\n        "/c",\n        "npx",\n        "-y",\n        "{appNameLower}-mcp-server@latest",\n        "--site-id={docsSiteId}"\n      ]\n    }\n  }\n}\n```\n\n- Cursor：添加到全局的 `~/.cursor/mcp.json` 或项目内的 `.cursor/mcp.json`\n- Cline：打开 Cline 面板 > MCP Server > Configure MCP Server\n\n## 🎯 如何使用\n\n安装配置好 MCP 后，{appName} MCP Server 会自动读取接口文档的数据并缓存在本地电脑，AI 可以通过 MCP 读取接口文档数据。\n\n你只要告诉 AI 你想要通过 API 文档做什么即可，示例：\n\n1. “通过 MCP 获取 API 文档，然后生成 Product 及其相关模型的定义代码”\n2. “根据 API 文档，在 Product DTO 里添加 API 文档新增的几个字段”\n3. “根据 API 文档给 Product 类的每个字段都加上注释”\n4. “根据 API 文档，生成接口 /users 相关的所有 MVC 代码”\n\n注意：接口文档数据默认是会缓存在本地的，如果接口文档内的数据有更新，请告诉 AI 刷新接口文档数据，否则 AI 读到的数据可能不是最新的。',
} as const;

export default messages;
